import { StretchIcon, styled } from 'canoe';
import React, { useCallback } from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

const VerticalStretch = styled(StretchIcon)`
  transform: rotate(90deg);
`;

interface Props {
  alignItems?: string;
  alignSelf?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
  isChild?: boolean;
}

export const AlignStretch = ({
  alignItems,
  alignSelf,
  flexDirection,
  toggleValues,
  isChild,
}: Props) => {
  const onClick = useCallback(() => {
    if (isChild) {
      toggleValues({
        alignSelf: 'stretch',
      });
    } else {
      toggleValues({
        alignItems: 'stretch',
      });
    }
  }, [isChild, toggleValues]);

  return (
    <ValueToggle
      toggleGroup={isChild ? 'self-align' : 'flex-align-items'}
      id={isChild ? 'self-align-stretch' : 'align-stretch'}
      data-cy="toolbox-flex-align-stretch"
      onClick={onClick}
      isActive={isChild ? alignSelf === 'stretch' : alignItems === 'stretch'}
      icon={flexDirection === 'row' ? VerticalStretch : StretchIcon}
      tooltip="Stretch"
      color="light"
    />
  );
};
